import React from "react";
import { Button, Popconfirm, Tag, Tooltip } from "antd";
import {
  CheckCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";
import {
  getBankColumn,
  getAccountNumberColumn,
  getCurrencyColumn,
  getBalanceUpdatedColumn,
  getWalletUpdatedColumn,
} from "./accountColumnHelpers";

function ActionButtons({ record, onToggleActive, togglingAccountId }) {
  const isActive = Boolean(record?.is_active);
  const isLoading = togglingAccountId === record?.id;

  const handleButtonClick = (event) => {
    event?.stopPropagation?.();
  };

  const handleConfirm = (event) => {
    event?.stopPropagation?.();
    onToggleActive?.(record, !isActive);
  };

  return (
    <div
      className="flex items-center justify-center gap-2"
      onClick={(event) => event.stopPropagation()}
    >
      <Tooltip title={isActive ? "Данс идэвхгүй болгох" : "Данс идэвхжүүлэх"}>
        <Popconfirm
          title={isActive ? "Данс идэвхгүй болгох уу?" : "Данс идэвхжүүлэх үү?"}
          description={
            isActive
              ? "Энэ нь гүйлгээ болон тайланд нөлөөлж болзошгүй."
              : "Данс ашиглах боломжтой болгоно."
          }
          okText="Тийм"
          cancelText="Үгүй"
          onConfirm={handleConfirm}
          onCancel={(event) => event?.stopPropagation?.()}
        >
          <Button
            loading={isLoading}
            danger={isActive}
            type={isActive ? "default" : "primary"}
            size="middle"
            icon={isActive ? <StopOutlined /> : <CheckCircleOutlined />}
            className="flex h-9 items-center rounded-xl px-3 font-medium shadow-sm"
            onClick={handleButtonClick}
          >
            {isActive ? "Идэвхгүй болгох" : "Идэвхжүүлэх"}
          </Button>
        </Popconfirm>
      </Tooltip>
    </div>
  );
}

export function headInstitutionAccountColumns({
  onToggleActive,
  togglingAccountId,
}) {
  return [
    {
      title: "Үйлдэл",
      key: "action",
      width: 160,
      align: "center",
      fixed: "left",
      render: (_, record) => (
        <ActionButtons
          record={record}
          onToggleActive={onToggleActive}
          togglingAccountId={togglingAccountId}
        />
      ),
    },
    getBankColumn(),
    getAccountNumberColumn(),
    getCurrencyColumn(),
    {
      title: "Төлөв",
      dataIndex: "is_active",
      key: "is_active",
      width: 140,
      align: "center",
      render: (value) =>
        value ? <Tag color="green">Идэвхтэй</Tag> : <Tag color="red">Идэвхгүй</Tag>,
    },
    getBalanceUpdatedColumn(),
    getWalletUpdatedColumn(),
  ];
}